import {
  ArrowRight,
  Banknote,
  Briefcase,
  ChartBar,
  Cog,
  DollarSign,
  FileText,
  Server,
  Shield,
  UserCheck,
  Building,
} from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SectionShell } from "./SectionShell";

/** id は /plans/<id> のルートと一対一。見出しと行き先が食い違わないよう1か所にまとめる。 */
const PLANS: { id: string; titleKey: string; subKey?: string; icon: ReactNode }[] = [
  { id: "posucoro", titleKey: "plans.posucoro", subKey: "plans.posucoro_sub", icon: <ChartBar /> },
  { id: "keiei-kaizen", titleKey: "plans.keiei_kaizen", subKey: "plans.keiei_kaizen_sub", icon: <FileText /> },
  { id: "bcp", titleKey: "plans.bcp", subKey: "plans.bcp_sub", icon: <Shield /> },
  { id: "jigyou-keizoku", titleKey: "plans.jigyou_keizoku", icon: <Building /> },
  { id: "keiei-ryoku", titleKey: "plans.keiei_ryoku", icon: <Cog /> },
  { id: "sentan-setsubi", titleKey: "plans.sentan_setsubi", icon: <Server /> },
  { id: "keiei-kakushin", titleKey: "plans.keiei_kakushin", icon: <Briefcase /> },
  { id: "dds", titleKey: "plans.dds", icon: <DollarSign /> },
  { id: "keieisha-hosho", titleKey: "plans.keieisha_hosho", icon: <UserCheck /> },
  { id: "safety-net", titleKey: "plans.safety_net", subKey: "plans.safety_net_sub", icon: <Banknote /> },
];

export const BusinessPlansSection = () => {
  const { t } = useTranslation();

  return (
    <SectionShell
      id="plans"
      icon={<FileText aria-hidden="true" focusable="false" />}
      heading={`${t("plans.heading1")}${t("plans.heading2")}`}
      photo={{ src: "/images/home/planning.jpg" }}
    >
      <p className="plan-intro" data-reveal>
        {t("plans.description")}
      </p>
      <div className="plan-grid">
        {PLANS.map(({ id, titleKey, subKey, icon }) => (
          <Link className="plan" key={id} to={`/plans/${id}`} data-reveal>
            {icon}
            <div>
              <h3>{t(titleKey)}</h3>
              {subKey && <p>{t(subKey)}</p>}
            </div>
            <span className="detail">
              {t("plans.detail")}
              <ArrowRight aria-hidden="true" focusable="false" />
            </span>
          </Link>
        ))}
      </div>
    </SectionShell>
  );
};
